import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzXmas80 } from './pages'

type TIdToPageMapWoofzXmas80 = Record<PageIdWoofzXmas80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_XMAS_80: TIdToPageMapWoofzXmas80 = {
  [PageId.SUBSCRIPTIONS_XMAS_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/subscriptions/SubscriptionWoofzXmas80'
      ).then((m) => ({
        default: m.SubscriptionsXmas80,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/subscriptions/SubscriptionWoofzXmas80'
      ),
  },
  [PageId.CHAT_UPSELL_XMAS_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_XMAS_80]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzXmas80.DOWNLOAD_XMAS_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzXmas80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
